import { render } from "./CreditCardFunds.vue?vue&type=template&id=0490f130"
import script from "./CreditCardFunds.vue?vue&type=script&lang=js"
export * from "./CreditCardFunds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__